import Glide from '@glidejs/glide';
import { Autoplay } from '@glidejs/glide/dist/glide.modular.esm';

function setCarouselHeight() {
    const glideElement = document.querySelector('.glide');
    if (!glideElement) return;

    const slides = glideElement.querySelectorAll('.glide__slide');

    glideElement.classList.add('carousel-loading');

    requestAnimationFrame(() => {
        slides.forEach((slide) => {
            slide.style.minHeight = '';

            const imgContainer = slide.querySelector('.slide-image-container');
            const caption = slide.querySelector('.slide-caption, p');

            if (imgContainer) {
                imgContainer.style.height = '';
                imgContainer.style.aspectRatio = window.innerWidth <= 768 ? '3 / 4' : '4 / 5';
            }

            if (caption) {
                caption.style.minHeight = '';
            }

            const img = slide.querySelector('img');
            if (img) {
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.objectFit = 'contain';
                img.style.objectPosition = 'center';
            }
        });

        glideElement.classList.remove('carousel-loading');
    });
}

// Throttled resize handler for better performance
let resizeTimeout;
function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        setCarouselHeight();
    }, 100);
}

export function initializeGlide() {
    const glideElement = document.querySelector('.glide');
    if (!glideElement) return;

    const glide = new Glide('.glide', {
        type: 'carousel',
        autoplay: 3000,
        hoverpause: true,
        animationDuration: 1200,
        animationTimingFunc: 'cubic-bezier(0.4, 0, 0.2, 1)',
        perView: 3,
        gap: 10,
        breakpoints: {
            768: {
                perView: 2,
                gap: 5,
                animationDuration: 1000,
            },
        },
    });
    glide.on('mount.after', () => {
        setCarouselHeight();
    });

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => {
        setTimeout(setCarouselHeight, 200);
    });

    // Glide measures the track's real pixel width (track.offsetWidth) the moment
    // mount() runs, and bakes that into every slide's width/height. If layout
    // hasn't fully settled yet at that instant, the wrong width gets locked in
    // and nothing corrects it until a later resize/update event happens to fire -
    // which is why it only ever "fixes itself" after you interact with the page.
    // Instead of mounting immediately and patching the result afterward, wait
    // for two full animation frames first so the browser has definitely finished
    // laying out the page before Glide takes its first measurement.
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            glide.mount({ Autoplay });

            // Safety net for any later layout shift (e.g. a real window resize) -
            // re-measure whenever the carousel's own box size actually changes.
            if (typeof ResizeObserver !== 'undefined') {
                let lastWidth = glideElement.offsetWidth;
                const resizeObserver = new ResizeObserver(() => {
                    const width = glideElement.offsetWidth;
                    if (width !== lastWidth) {
                        lastWidth = width;
                        glide.update();
                    }
                });
                resizeObserver.observe(glideElement);
            }
        });
    });
}